export const calculateProductRating = (ratingsArray) => {
    let sum = ratingsArray?.reduce((acc, rating) => acc + rating.score, 0);
    return ratingsArray?.length > 0 ? sum / ratingsArray?.length : 0;
}